var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductInPreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.66 343.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#262626;}.cls-2{stroke:#231f20;stroke-width:5px;}.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke:#fff;stroke-width:7px;}.cls-4{fill:#656392;}.cls-5{fill:#afafd8;}.cls-6{fill:#d1d3d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 138.83,
    cy: 138.83,
    r: 138.83
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "215.41 99.7 201.19 166.68 86.42 166.68 86.41 166.68 72.12 99.7 215.41 99.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.8,202.24c6.88,0,12.45,5.57,12.45,12.44s-5.57,12.45-12.45,12.45-12.44-5.57-12.44-12.45,5.57-12.44,12.44-12.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.3,202.24c6.87,0,12.44,5.57,12.44,12.44s-5.57,12.45-12.44,12.45-12.44-5.57-12.44-12.45,5.57-12.44,12.44-12.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.42,166.68l2.78,13.05c1.03,4.83,5.3,8.29,10.24,8.29h97.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.5,71.13l19.83,8.52c3.12,1.35,5.39,4.12,6.1,7.44l2.69,12.61,14.29,66.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "72.12 99.7 215.41 99.7 201.19 166.68 86.42 166.68 86.41 166.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.77,
    y1: 115.13,
    x2: 143.77,
    y2: 135.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.77,
    y1: 148.66,
    x2: 143.77,
    y2: 149.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.74,214.68c0-6.87-5.57-12.44-12.44-12.44s-12.44,5.57-12.44,12.44,5.57,12.45,12.44,12.45,12.44-5.57,12.44-12.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.25,214.68c0-6.87-5.57-12.44-12.45-12.44s-12.44,5.57-12.44,12.44,5.57,12.45,12.44,12.45,12.45-5.57,12.45-12.45Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.22,323.69H.7v-2.21H6.18v-2.83h2.78v2.83h5.26v2.21Zm-6.67,10.58c-3.29,0-5.59-1.92-5.59-4.72s2.29-4.72,5.59-4.72,5.61,1.89,5.61,4.72-2.29,4.72-5.61,4.72Zm0-2.19c1.78,0,3-.95,3-2.54s-1.21-2.56-3-2.56-2.97,1-2.97,2.56,1.21,2.54,2.97,2.54Zm13.85,8.26v2.27H4.96v-6.88h2.81v4.62h13.63Zm-3.35-7.94h-3.73v-2.24h3.73v-2.92h-3.73v-2.27h3.73v-6.29h2.78v18.6h-2.78v-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.91,325.01c0,4.4,1.54,8.39,5.07,10.23l-1.62,2.13c-2.32-1.27-3.83-3.48-4.72-6.18-.84,3.1-2.4,5.59-4.8,7.02l-1.7-2.08c3.54-2.05,5.07-6.29,5.07-11.12v-1.35h-4.4v-2.29h11.17v2.29h-4.08v1.35Zm13.5-6.34v24.4h-2.65v-12.47h-2.67v11.34h-2.62v-22.81h2.62v9.18h2.67v-9.64h2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.6,332.03c-2.62-.94-4.56-2.81-5.59-5.1-1.08,2.65-3.08,4.75-5.88,5.78l-1.48-2.21c3.83-1.32,5.91-4.64,5.91-8.15v-2.4h2.81v2.62c0,3.13,2.08,6.1,5.7,7.29l-1.46,2.19Zm6.59,6.45c0,2.89-3.08,4.59-8.12,4.59s-8.12-1.7-8.12-4.59,3.1-4.56,8.12-4.56,8.12,1.7,8.12,4.56Zm-2.75,0c0-1.51-1.97-2.38-5.37-2.38s-5.37,.86-5.37,2.38,1.97,2.4,5.37,2.4,5.37-.84,5.37-2.4Zm5.94-13.77v2.29h-3.46v6.32h-2.78v-14.66h2.78v6.05h3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.11,332.54v2.48h6.96v7.75h-16.74v-7.75h6.99v-2.48h-9.64v-2.24h22.05v2.24h-9.64Zm-6.99-10.9h-3.46v-2.24h18.06v2.24h-3.43v4.48h3.29v2.24h-17.79v-2.24h3.32v-4.48Zm11.23,15.6h-11.26v3.32h11.26v-3.32Zm-2.83-15.6h-5.61v4.48h5.61v-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.2,331.05v2.24h-9.45v4.59h-2.78v-4.59h-9.88v-2.24h22.11Zm-20.92-3.7c4.59-.54,7.75-2.81,7.96-5.29h-7.1v-2.24h18v2.24h-7.15c.22,2.48,3.43,4.75,7.99,5.29l-1.03,2.21c-4.24-.54-7.53-2.48-8.85-5.18-1.29,2.7-4.56,4.64-8.77,5.18l-1.05-2.21Zm4.29,12.98h14.17v2.27h-16.95v-6.96h2.78v4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.01,320.69v6.21h6.18v-6.21h2.78v16.63h-11.71v-16.63h2.75Zm0,14.39h6.18v-5.97h-6.18v5.97Zm16.01-16.41v24.46h-2.81v-24.46h2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.75,332.16v2.27c4.4,.27,6.96,1.78,6.96,4.32,0,2.75-3.13,4.32-8.39,4.32s-8.39-1.57-8.39-4.32c0-2.54,2.62-4.08,7.04-4.35v-2.24h-9.64v-2.21h22.05v2.21h-9.64Zm-11.31-5.64c4.51-.46,7.64-2.35,8.02-4.54h-7.07v-2.24h18v2.24h-7.13c.38,2.19,3.51,4.08,8.02,4.54l-.97,2.19c-4.29-.46-7.64-2.21-8.93-4.72-1.32,2.51-4.67,4.27-8.93,4.72l-1-2.19Zm9.88,10.01c-3.56,0-5.56,.76-5.56,2.21s2,2.19,5.56,2.19,5.59-.78,5.59-2.19-2.02-2.21-5.59-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.59,325.47c0,3.35-2.73,5.67-6.45,5.67s-6.48-2.32-6.48-5.67,2.75-5.67,6.48-5.67,6.45,2.32,6.45,5.67Zm-10.2,0c0,2.05,1.54,3.37,3.75,3.37s3.75-1.32,3.75-3.37-1.57-3.37-3.75-3.37-3.75,1.35-3.75,3.37Zm3.73,7.45v2.7h10.42v-2.7h2.75v9.85h-15.93v-9.85h2.75Zm0,7.61h10.42v-2.75h-10.42v2.75Zm13.17-21.84v13.09h-2.78v-13.09h2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.22,334.54c3.46-.03,7.1-.32,10.93-1.11l.3,2.32c-4.18,.86-8.12,1.16-11.9,1.16h-2.08v-15.84h2.75v13.47Zm15.95-15.84v24.37h-2.78v-24.37h2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.63,334.78c3.94-.03,6.91-.19,10.31-.78l.3,2.29c-3.7,.67-6.99,.81-11.39,.81h-2v-16.12h11.34v2.27h-8.56v11.53Zm18.92-4.43h-3.81v12.74h-2.78v-24.43h2.78v9.39h3.81v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.29,339.18c0-1.27,.92-2.21,2.08-2.21s2.08,.94,2.08,2.21-.92,2.16-2.08,2.16-2.08-.89-2.08-2.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductInPreparation);
export default __webpack_public_path__ + "static/media/ProductInPreparation.c643a0e595c7bce45fee718f925589f6.svg";
export { ForwardRef as ReactComponent };